<template>
    <div>
        <div :id="id" v-mdl class="item" :class="{ unread: unread }" @click="routeToList">
            <span class="name">{{ name }}</span>
            <span v-if="unread" class="unread-dot" :style="{ background: $store.state.colors_accent }"></span>
            <button class="edit-button mdl-button mdl-js-button mdl-button--icon" :title="$t('folders.edit')" @click.stop="routeToEdit">
                <i class="material-icons">edit</i>
            </button>
        </div>
    </div>
</template>

<script>

export default {
    name: 'FolderItem',
    // `unread` is read straight from the prop (not copied into data) so the dot updates
    // when the parent's unread list arrives after the rows are created.
    props: [ 'folderData', 'unread' ],

    computed: {
        // Read from the prop, not data(), so a rename shows without remounting the row.
        id () {
            return this.folderData.device_id;
        },

        name () {
            return this.folderData.name;
        }
    },

    methods: {
        routeToEdit () {
            this.$router.push({ name: 'edit-folder', params: { folderId: String(this.id) } }).catch(() => {});
        },

        routeToList () {
            this.$router.push({
                name: 'conversations-list-folder', params: { index: 'folder', small: false, folderId: this.id, folderName: this.name }
            }).catch(() => {});
        }
    }

};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    @import "../../assets/scss/_vars.scss";

    body.dark {
        .item:hover {
            background: #202020;
        }

        .item .edit-button {
            color: rgba(255, 255, 255, 0.54);
        }
    }

    .item {
        display: flex;
        align-items: center;
        box-sizing: border-box;
        height: 40px;
        line-height: 40px;
        width: 100%;
        padding-left: 16px;
        padding-right: 16px;

        &.unread .name {
            font-weight: bold;
        }

        .name {
            flex: 1;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
        }

        .unread-dot {
            flex: none;
            width: 8px;
            height: 8px;
            margin-left: 8px;
            border-radius: 50%;
        }

        .edit-button {
            flex: none;
            margin-left: 8px;
            color: rgba(0, 0, 0, 0.54);
        }
    }

    .item:hover {
        background: #E0E0E0;
        cursor: pointer;
    }


</style>
